<a [href]="value.link">
    {{ value.text }}
</a>
<a href="" class="icon" (click)="onClose($event)" title="Luk">
    <mat-icon svgIcon="app-info-close"></mat-icon>
</a>
